import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

function PlayerCards({ name, cards, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <h4>{name}</h4>{" "}
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_IMG} className="winner-icon" alt="" />
          </div>
        )}
        {cards.map((c, i) => (
          <React.Fragment key={i}>
            {" "}
            <div className="casino-result-cards-item">
              <img src={getCardImage(c)} alt="" />
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

/**
 * Reference result body for Instant Teenpatti (teen3 / teen32 / teen33): same shape as Teenpatti 1-day
 * (A = cards[0,2,4], B = cards[1,3,5], trophy before the winner's cards) but the description column
 * shows only Winner (rdesc before the first "#"). Columns render only when there are cards / a desc.
 */
export default function TeenInstantResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim()).filter(Boolean);
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  // Winner from winnat / rdesc, else win 1|2; "0" = not decided yet (tenexch 027d4d55).
  const named = [t1?.winnat, desc[0]].map((v) => String(v ?? "").trim()).find((v) => /player [ab]/i.test(v)) || "";
  const winA = win === "1" || /player a/i.test(named);
  const winB = win === "2" || /player b/i.test(named);
  const rawWinner = String(desc[0] ?? "").trim();
  const winner = named || (winA ? "Player A" : winB ? "Player B" : rawWinner !== "0" ? rawWinner : "");

  return (
    <div className="row row5">
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <PlayerCards name="Player A" cards={[cards[0], cards[2], cards[4]]} isWinner={winA} />{" "}
            <div className="casino-result-content-diveder" />{" "}
            <PlayerCards name="Player B" cards={[cards[1], cards[3], cards[5]]} isWinner={winB} />
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {winner && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{winner}</div>
            </div>{" "}
          </div>
        )}
      </div>
    </div>
  );
}
